import { bookingInquiryStrings } from '@data/bookingInquiry';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${bookingInquiryStrings.consignee}一覧`,
  },
});

export const meta: PageMeta = {
  title: strings.title,
};
